// Browser authentication client only. All organization data access goes through the authenticated API.
import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const publishableKey = (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY) as string;

if (!url || !publishableKey) {
  throw new Error('Missing VITE_SUPABASE_URL or a browser-safe Supabase publishable/anon key');
}

export const supabase = createClient(url, publishableKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
